<template>
  <div class="container"></div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>

</style>